import React, { useState } from "react";
import { CARE_SETTING_OPTIONS } from "../../../constants/careContextOptions";
import { CustomizableAutocomplete } from "../../UI";

const CareSettingAutocomplete = ({
  suggestedOptions = [],
  value = [],
  onChange,
  sx,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const visibleOptions = searchInput.trim()
    ? CARE_SETTING_OPTIONS
    : suggestedOptions;

  return (
    <CustomizableAutocomplete
      options={visibleOptions}
      inputValue={searchInput}
      onInputChange={(event, nextValue) => setSearchInput(nextValue)}
      getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
      value={value}
      onChange={(event, nextValue) => onChange?.(nextValue)}
      label="Care setting"
      addText="Add setting"
      helperText="Choose a common setting or type to search all care settings."
      sx={sx}
    />
  );
};

export default CareSettingAutocomplete;
